import { Link } from "react-router-dom";
import { ArrowUpRight, PaintBucket, Droplet, Accessibility, Brush, Megaphone, ZapOff } from "lucide-react";
import { SERVICES } from "@/lib/site";

const ICONS = {
  "parking-lot-striping": PaintBucket,
  sealcoating: Droplet,
  "ada-compliance": Accessibility,
  restriping: Brush,
  "pavement-markings": Megaphone,
  "crack-filling": ZapOff,
};

export default function ServicesGrid({ compact = false }) {
  const items = compact ? SERVICES.slice(0, 4) : SERVICES;
  return (
    <section
      data-testid="services-grid"
      className="py-20 md:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-blue-700">
            What we do
          </div>
          <h2 className="mt-3 font-display font-bold tracking-tight text-slate-900 text-3xl sm:text-4xl">
            Pavement services for Mid-South businesses
          </h2>
          <p className="mt-4 text-base text-slate-600 leading-relaxed">
            Every project starts with a free site walk. We give you a
            written quote, a clear schedule, and a crew that shows up on
            time.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((s) => {
            const Icon = ICONS[s.slug] || PaintBucket;
            return (
              <Link
                key={s.slug}
                to="/services"
                data-testid={`service-card-${s.slug}`}
                className="group relative bg-white border border-slate-200 p-8 rounded-lg shadow-sm hover:shadow-lg hover:border-blue-300 transition-all duration-200"
              >
                <div className="flex items-start justify-between">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-md bg-blue-50 text-blue-700 group-hover:bg-blue-700 group-hover:text-white transition-colors">
                    <Icon className="h-6 w-6" />
                  </span>
                  <ArrowUpRight className="h-5 w-5 text-slate-400 group-hover:text-orange-600 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
                </div>
                <h3 className="mt-6 font-display font-semibold text-slate-900 text-xl">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                  {s.short}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
